module.exports = __webpack_public_path__ + "static/media/dont5.f9bc1bc3.png";